<template>
	<v-layout row wrap>
		<v-flex md8 class="body-border-right body-border-right-full pl-0">
			<div class="form-section">
				<p class="text-xs-left medium">Nuevo estado</p>
			</div>
			<v-container fluid v-bind="{ ['grid-list-xl'] : true }">
				<v-layout row wrap class="form-section text-xs-left">
					<v-flex md4>
						<div class="label-section mb-2">
							<label for="name">Nombre del estado para la hab.</label>
						</div>
						<div class="control">
							<input
								id="name"
								name="name"
								type="text"
								v-model="model.name"
								class="input-form"
								placeholder="Ejem. Ocupado sucio"
							/>
						</div>
					</v-flex>
					<v-flex md4>
						<div class="label-section mb-2">
							<label for="code">Siglas de la habitación</label>
						</div>
						<div class="control">
							<input
								id="code"
								name="codeState"
								type="text"
								v-model="model.codeState"
								class="input-form"
								placeholder="Ejem. OS"
							/>
						</div>
					</v-flex>
					<v-flex md4>
						<div class="label-section mb-2">
							<label for="color">Color picker</label>
						</div>
						<div class="control">
							<div class="color-picker">
								<v-menu
									v-model="showColorPicker"
									offset-x
									:close-on-content-click="false"
									top
									full-width>
									<div slot="activator">
										<input
											id="color"
											name="colorState"
											type="text"
											class="input-form"
											v-model="model.colorState"
										/>
										<div class="current-color"
											:style="currentPicker">
										</div>
									</div>
									<v-list class="menu-color-picker">
										<button type="button" class="btn-danger"
											@click="showColorPicker = false">Cerrar</button>
										<chrome-picker
											:value="colors"
											@input="onUpdateColor" />
									</v-list>
								</v-menu>
							</div>
						</div>
					</v-flex>
				</v-layout>
			</v-container>
			<v-container fluid v-bind="{ ['grid-list-md'] : true }" text-xs-left mt-3>
				<div class="label-section mb-2">
					<label>Seleccione el ícono</label>
				</div>
				<v-layout row wrap class="form-section text-xs-left">
					<v-flex md1 v-for="state in states" :key="state.id">
						<input
							type="radio"
							hidden
							name="icons"
							:value="state"
							v-model="model.stateSelected"
							v-on:change="updateIcon()"
							:id="state.id">
						<label :for="state.id" class="select-icon-states">
							<img :src="state.imageUrl" alt="">
						</label>
					</v-flex>
				</v-layout>
			</v-container>
			<v-layout row wrap>
				<v-flex xs3>
					<div class="form-section text-xs-left">
						<div class="label-section mt-4 mb-2">
							<label>Subir ícono</label>
						</div>
						<file-upload-container
							class="mb-3"
							v-bind:label-for="`image-${model.image.id}`"
							v-on:upload="onUploadImage"
							v-bind:image-url="model.image.imageUrl"
							v-bind:min-resolution="20"
							v-bind:max-resolution="20"
						/>
					</div>
				</v-flex>
			</v-layout>
			<v-layout row wrap>	
				<v-flex xs12>	
					<v-checkbox
						class="input-checkbox"
						label="Asignar este estado a habitaciones nuevas"	
						v-model="model.flagDefault">
					</v-checkbox>	
				</v-flex>	
			</v-layout>
			<v-layout row wrap>
				<v-btn
					class="btn-save mr-3"
					v-on:click="createState"
					:loading="loading"
					:disabled="loading">
					Guardar
				</v-btn>
				<v-btn class="btn-cancel" :to="statesHref">
					Cancelar
				</v-btn>
			</v-layout>
		</v-flex>
		<v-flex md4>
			<div class="form-section">
				<p class="text-xs-center medium">Vista previa</p>
			</div>
			<v-layout row wrap justify-center>
				<v-flex xs6>
					<v-layout row wrap justify-center class="new-state-container">
						<v-flex xs12>
							<room-status
								:class="{ 'topProperty' : !model.name }"
								:background-color="model.colorState"
								:status-icon-img="modelImage"
								:name="model.codeState"
								:room="model">
							</room-status>
						</v-flex>
						<v-flex xs12>
							<p>{{ model.name }}</p>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
import { Chrome } from 'vue-color';
import helper from '@/shared/helper';
import mixin from '@/shared/mixins';
import FileUploadContainer from '@/components/shared/FileUpload/FileUploadContainer';
import RoomStatus from '@/components/shared/RoomStatus';

const helperData = helper.data();
const DEFAULT_COLOR = '#14E1BF';

const defaultProps = {
	hex: DEFAULT_COLOR,
	hsl: {
		h: 150,
		s: 0.5,
		l: 0.2,
		a: 1,
	},
	hsv: {
		h: 150,
		s: 0.66,
		v: 0.30,
		a: 1,
	},
	rgba: {
		r: 25,
		g: 77,
		b: 51,
		a: 1,
	},
	a: 1,
};

function created() {
	if (this.stateId) {
		this.loadData();
	}
}

async function createState() {
	const method = this.stateId && this.stateId > 0 ? 'put' : 'post';
	const url = this.stateId && this.stateId > 0 ? `states/${this.stateId}` : 'states';
	const message = this.stateId && this.stateId > 0 ? 'actualizó' : 'creó';
	const modelSend = {
		name: this.model.name,
		flagActive: 1,
		codeState: this.model.codeState,
		colorState: this.model.colorState,
		flagDefault: this.model.flagDefault,
	};
	if (this.model.image.imageUrl !== this.preimage) {
		modelSend.iconUrl = this.model.image.imageUrl;
	} else if (this.model.stateSelected.imageUrl !== this.preimage) {
		modelSend.iconUrl = this.model.stateSelected.imageUrl;
	} else {
		modelSend.iconUrl = '';
	}
	try {
		await this.$http[method](`${process.env.PMS_URL}/${url}`, modelSend);
		this.showNotification(`El estado se ${message} correctamente.`, 'success');
		this.$router.push(this.statesHref);
	} catch (err) {
		if (err.status === 400) {
			if (err.data.codeState) {
				this.showNotification('El código ya existe.', 'error');
			}
		}
	}
}

async function loadData() {
	const { data: state } = await this.$http.get(`${process.env.PMS_URL}/states/${this.stateId}`);
	state.data.stateSelected = {
		id: 4,
		imageUrl: 'outofservice',
	};
	state.data.image = {
		id: 1,
		imageUrl: state.data.iconUrl || state.data.imageUrl || helperData.preimageUrl,
	};
	this.model = state.data;
}

function modelImage() {
	return this.model.image.imageUrl === this.preimage ?
		this.model.stateSelected.imageUrl : this.model.image.imageUrl;
}

function onUpdateColor({ hex }) {
	this.model.colorState = hex;
}

function onUploadImage(url, label) {
	if (this.stateId) {
		this.model.urlImage = url;
		this.model.image.imageUrl = url;
		this.model.iconUrl = null;
	} else {
		const image = this.model.image;
		image.id = Number(label.split('-')[1]);
		image.imageUrl = url;
	}
}

function updateIcon() {
	this.model.urlImage = null;
	this.model.image.imageUrl = helperData.preimageUrl;
}

function currentPicker() {
	return `background-color: ${this.model.colorState}`;
}

function data() {
	return {
		colors: defaultProps,
		loading: false,
		model: {
			codeState: 'F',
			colorState: DEFAULT_COLOR,
			flagDefault: false,
			image: {
				id: 1,
				imageUrl: helperData.preimageUrl,
			},
			name: 'Fumigación',
			stateSelected: {
				id: 4,
				imageUrl: 'outofservice',
			},
		},
		preimage: helperData.preimageUrl,
		resource: null,
		statesHref: { name: 'states-list' },
		states: [
			{ id: 1, imageUrl: helperData.turnoverImageUrl },
			{ id: 2, imageUrl: helperData.maintenanceImageUrl },
			{ id: 3, imageUrl: helperData.cleandeepImageUrl },
			{ id: 4, imageUrl: helperData.outofserviceImageUrl },
			{ id: 5, imageUrl: helperData.lockedImageUrl },
			{ id: 6, imageUrl: helperData.dirtyImageUrl },
			{ id: 7, imageUrl: helperData.indeterminateImageUrl },
		],
		showColorPicker: false,
	};
}

export default {
	name: 'states-create',
	components: {
		'chrome-picker': Chrome,
		FileUploadContainer,
		RoomStatus,
	},
	computed: {
		currentPicker,
		modelImage,
	},
	created,
	data,
	methods: {
		createState,
		loadData,
		onUpdateColor,
		onUploadImage,
		updateIcon,
	},
	mixins: mixin,
	props: ['stateId'],
};
</script>

<style lang="scss" scoped>
	.form-section {
		.medium {
			color: map-get($colors, default-dark);
			font-family: map-get($fonts, medium);
			font-size: map-get($sizes, fourteen);
		}
	}

	.select-icon-states {
		align-items: center;
		background-color: white;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, .18);
		cursor: pointer;
		display: inline-flex;
		height: 40px;
		justify-content: center;
		width: 42px;
	}

	.new-state-container {
		align-content: center;
		background-color: white;
		box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, .1);
		height: 104px;
		width: 183px;

		.chip-status.large {
			margin-bottom: 0px;
			margin-right: 0px;
		}

		p {
			align-self: flex-start;
			color: map-get($colors, default-label);
			margin-bottom: 0px;
		}
	}

	input[type="radio"]:checked + .select-icon-states {
		border: 1px solid map-get($colors, default-skyblue);
	}

	.color-picker {
		position: relative;
	}

	.current-color {
		bottom: 0;
		height: 24px;
		margin: auto;
		position: absolute;
		right: 8px;
		top: 0;
		width: 24px;
	}
</style>



// WEBPACK FOOTER //
// Create.vue?2f464374